import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import AssistanceModal from 'components/AssistanceModal';

const renderInteractiveMessage = (message, toggleAssistance) => {
    if (message?.includes('{customerSupport}')) {
        const parts = message.split('{customerSupport}');
        return (
            <>
                {parts[0]}
                <Button
                    color="link"
                    className="customer-support-link"
                    onClick={toggleAssistance}
                >
                    customer support
                </Button>
                {parts[1]}
            </>
        );
    }
    return message;
};

const ErrorAlert = ({ error }) => {
    const [displayAssistance, setDisplayAssistance] = useState(false);

    const toggleDisplayAssistance = (e) => {
        if (e) e.preventDefault();
        setDisplayAssistance((open) => !open);
    };

    const getClassNames = () => {
        return 'd-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row align-items-center mb-2 justify-content-between';
    };

    const messageContent =
        error?.errorType === 'interactive'
            ? renderInteractiveMessage(error.errorMessage, toggleDisplayAssistance)
            : error?.errorMessage;

    return (
        <>
            <Alert color="danger" className={getClassNames()}>
                <span>{messageContent}</span>
                {error.button?.link && (
                    <Link
                        to={{
                            pathname: error.button.link,
                            search: window.location.search,
                        }}
                        className="btn btn-sm btn-danger justify-content-sm-center my-auto"
                        style={{ whiteSpace: 'nowrap' }}
                        id={error.button.id}
                    >
                        {error.button.text}
                    </Link>
                )}
            </Alert>
            {error?.errorType === 'interactive' && (
                <AssistanceModal
                    displayAssistance={displayAssistance}
                    toggleDisplayAssistance={toggleDisplayAssistance}
                />
            )}
        </>
    );
};

export default ErrorAlert;
